import { connect } from 'react-redux';
import { setError } from '@/actions';
import { newPurchase } from '@/actions/purchase';

import resolveSelectedExchangeTicket from 'utils/exchangeSelectedTicket';
import ExchangeTripList from './ExchangeTripList';

const mapStateToProps = ({ config, exchange, tripFilters, seatsBus }, ownProps) => {
  const {
    ticket: { nit, openTicket, document, email },
    trip: originalTrip,
    passengers,
    walletOriginalType,
    parentHasFlatfare,
    selectedPassengerToAlter,
    allPassengers,
    transporter,
  } = exchange;
  const operationNumbers = passengers?.map((passenger) => passenger.transporterKey);

  // Get the selected passenger info for display. Shared with the redesigned schedule summary so
  // both show the same ticket — they used to answer this separately and disagreed.
  const { ticket: selectedPassenger } = resolveSelectedExchangeTicket({
    selectedPassengerToAlter,
    allPassengers,
    passengers,
  });

  return {
    operationNumbers,
    nit,
    document,
    openTicket,
    email,
    // Task 8.6/8.7 (openspec/changes/iamsa-b2c-ticket-exchange, platform-sre): explicit
    // transporter chosen via the IAMSA line selector, if any. The schedule route owns it —
    // it travels in `?transporter=` and is checked against `exchanges/lines` there — and is
    // available before the revalidation lands, so an own prop wins over the stored value.
    transporter: ownProps.transporter ?? transporter,
    paymentPlans: config.paymentPlans || [],
    installmentsMinAmount: config.installmentsMinAmount,
    tripFilters,
    walletOriginalType,
    parentHasFlatfare,
    // Original ticket info for display
    originalTrip,
    selectedPassenger,
    // Exchange passenger data for seat selection limits
    exchangePassengers: passengers,
    // Seats state for getting selected seats from results
    seatsBus,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setError: () => dispatch(setError(1, 'Ocurrio un error al buscar viajes', 'warning', false)),
    newPurchase: (originSlug, seenPrice, exchangeData = {}, preSelectedSeats) => {
      return dispatch(
        newPurchase(
          originSlug,
          null,
          'A1',
          seenPrice,
          false,
          true,
          exchangeData,
          false, // redirect
          '', // redirectedFrom
          null, // tripInfo
          preSelectedSeats, // preSelectedSeats - this will be sent as pre_selected_seats to backend
        ),
      );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ExchangeTripList);
